import React, { useEffect,useContext,useMemo, useState } from "react";
import { AppContext, UserContext } from "../../../AppContextProvider";
import { useNavigate, useParams } from "react-router-dom";
import { useFetch } from "../../api/FetchApiData";
import { MediaUrl } from "../../utils/media/Media";
import { BrowserView, isMobile, MobileView } from "react-device-detect";
import Select from "react-select";
import { QRCodeSVG } from "qrcode.react";
import { SaleComment, TicketView, TicketViewPopUp } from "../sales/Sale";
import { Rating } from "react-simple-star-rating";
import home_icon from '../../map/icons/home.webp';
import store_icon from '../../map/icons/shop.webp';
import { useTranslation } from "react-i18next";
import InvoiceDocument from "./Invoice";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { QrPackageTicket } from "../../utils/QR/QrCodeScan";

if (isMobile)
    import('./order_mob.css').then(() => {});
else
    import('./order.css').then(() => {});

const ORDER_LIST_STATUS = ['En attente','Confirmée', 'Annulée', 'Terminée'];
const ORDER_ARTICLE_LIST_STATUS = ["Commande en préparation","Expediée", "En boutique partenaire","En dêpot", "Livré"];

function ButtonQrPackage({close=()=>{}})
{
   return(
    <div className="back-screen" style={{position:'fixed',top:'0px',left:'0px'}}>
        <div style={{width:'95%',backgroundColor:'white',position:'relative',top:'100px',margin:'auto',paddingTop:'10px'}}>
            <QrPackageTicket close={close} />
        </div>
    </div>
   ) 
}


export default function Order()
{
    const [order,setOrder] = useState({payments:[],owned:false,customer:{label:''},address:{label:''},articles:[],historic:[],status:'en attente',total_price:0,customer_ticket:''})
    const [AppState,setAppState] = useContext(AppContext);
    const fetchData = useFetch();
    const [UserState,setUserState] = useContext(UserContext);
    const {id} = useParams();
    const [locations,setLocations] = useState([null,null]);
    const {t}=useTranslation();
    const [scanner,setScanner] = useState({display:'none',data:null});
    const navigator = useNavigate();
    const invoice = useMemo(() => {
            if (order.id === undefined) return null;
            return {
                number:      'INV' + order.order_number,
                status:      order.status === 'en attente' ? 'Non Payée' : 'Payée',
                date:        order.date.split('T')[0],
                contact:     'djamnazi@always-data.fr',
                payment:     order.payments.length > 0 ? order.payments.map(p => p.mode).join(', ') : 'N/A',
                collectedBy: order.payments.length > 0 ? order.payments.map(p => p.cashier.name).join(', ') : 'N/A',
                items:       order.articles.map(art => ({
                name:    art.title,
                variant: art.deliver?.title ?? 'N/A',
                qty:     art.quantity,
                price:   art.price,
                })),
                shipping: order.delivery_price,
                total: order.total_price,
                devise: AppState.settings.devise==='euro'?' €':' KMF',
                vatRate:  0.00,
            };
        }, [order,AppState.settings.devise]);
    
    useEffect(()=>{
        if(!UserState.auth)
            navigator('/');
    },[UserState.auth])

    const LocationSelectOption = (location = {label : 'Chez Maman Cheikh', ville:'Ngnadomboeni Hamahamer'},is_location=true)=>{
        if(is_location)
        {
            let imgsrc = home_icon;
            if(location.type==='partner_point')
                imgsrc = store_icon;
            return(
                <div key={location.label} style={{fontSize:isMobile?'xx-small':'x-small'}}>
                    <img src={imgsrc} style={{width:'25px',height:'25px',marginRight:'5px',verticalAlign:'middle',borderRadius:'15px',display:'inline-block'}} />
                    <div style={{display:'inline-block',width:'82%',verticalAlign:'middle',textAlign:'center'}}>
                        <label>{location.label}</label><br/>
                        <span style={{color:'rgb(120,120,120)'}}>{location.display_name}</span>
                    </div>
                </div>);
        }
        else
        {
            return(
            <div key={location.title} style={{fontSize:isMobile?'xx-small':'x-small'}}>
                <img src={MediaUrl(location.logo.image)} style={{width:'30px',height:'30px',verticalAlign:'middle',borderRadius:'15px',display:'inline-block'}} />
                <div style={{display:'inline-block',width:'82%',verticalAlign:'middle',textAlign:'center'}}>
                <label>{location.title}</label><br/>
                    <span style={{color:'rgb(120,120,120)'}}>{location.phone}</span>
                </div>
            </div>);
        }
    }

    const PartnerOption = (deliver)=>{
            if(deliver === null || deliver === undefined)
                return;
            return({ label:
                <div key={deliver.title} style={{fontSize:'small'}}>
                    <div style={{display:'inline-block',verticalAlign:'middle',maxWidth:'50px'}}>
                        <div style={{margin:'auto',marginBottom:'-6px'}}>
                            <img src={MediaUrl(deliver.logo.image)} style={{margin:'auto',width:'20px',height:'20px',borderRadius:'15px'}} />
                        </div>
                        <Rating st initialValue={2.5} size={8} style={{}} />
                    </div>
                    <div style={{display:'inline-block',width:'77%',verticalAlign:'middle',fontSize:'xx-small',textAlign:'center'}}>
                        <label>{deliver.title}</label><br/>
                        <label style={{color:'gray',fontSize:'xx-small'}}>{deliver.phone}</label>
                    </div>
                </div>});
    }

    useEffect(()=>{
        if(!UserState.auth)
            navigator("/");
        let user_id = UserState.id;
        if(user_id === undefined || user_id === null)
            user_id = 'self';
        if(!!id)
            fetchData.GetData(`user/order/${user_id}/${id}/1/`).then((result)=>{
                if(result.result)
                {
                    setOrder({...result.order});
                    console.log(result.order);
                    if(!!result.order.address)
                        setLocations([{label:LocationSelectOption(result.order.address,true)}   ])
                    
                }
            });
    },[AppState.settings.devise])

    const Promo = (art)=>
    {
        if(!!art.promo)
            return (<>
                <span> -{art.promo[0].reduction}% ({art.promo[0].title})</span>
            </>)
    }

    const _status = (status)=>{
        if(typeof(status)===typeof('status'))
            return status
        else
            return status.status
    }

    const Status_article=(status)=>{
        if(status===ORDER_ARTICLE_LIST_STATUS[0])
            return t('order.perp-en-cours');
        else if(status===ORDER_ARTICLE_LIST_STATUS[1])
            return t('order.expedie')
        else if(status===ORDER_ARTICLE_LIST_STATUS[2])
            return t('order.boutique-partner')
        else if(status===ORDER_ARTICLE_LIST_STATUS[3])
            return t('order.en-depot')
        else if(status===ORDER_ARTICLE_LIST_STATUS[4])
            return t('order.livre')
        else
            return '';
    }

    const Status = ()=>{
        let text = ''
        let status = order.status;
        if(_status(order.status)===ORDER_LIST_STATUS[0])
        {
            text =  <div style={{textAlign:'center',width:'100%'}}>
                        <span style={{maxWidth:'90%',display:'block',margin:'auto',margin:'5px'}}>{t('order.info-attente')}<br/>
                        <span dir="rtl" style={{fontWeight:'bold'}}>{t('order.temps-restant')} 3h 48min</span></span>
                        { order.owned && <input type="button" value={t('order.trouver-partenaire')} style={{height:'40px',
                            backgroundColor:'lightblue',
                            borderRadius:'5px',
                            border:'none',
                            margin:'5px 5px 10px 5px',
                            padding:'3px 20px 3px 20px',
                            color:'black',width:'60%'}} />}
                    </div>;
            status = t('order.attente');
        }
        else if(_status(order.status)===ORDER_LIST_STATUS[1])
        {
            text = <span>{t("order.c_confirme")+' '+order.status.date??''}</span>;
            status = t('order.confirme');
        }
        else if(_status(order.status)===ORDER_LIST_STATUS[3])
        {   
            text = <span style={{maxWidth:'90%',display:'block',margin:'auto',margin:'0px 0px 5px 0px'}}>{t('order.c_expedier')+' '+order.status.date??''}</span>;
            status = t('order.expedie');
        }
        else if(_status(order.status)===ORDER_LIST_STATUS[2])
        {   
            text = <span style={{maxWidth:'90%',display:'block',margin:'auto',margin:'0px 0px 5px 0px'}}>{t('order.c_annule')+' '+order.status.date??''}</span>;
            status = t('order.annule');
        }
        else if(_status(order.status)===ORDER_LIST_STATUS[4])
        {text = <span>{t('order.c_livre')+' '+order.status.date??''}</span>;
            status = t('order.livre');}
        else
        {text = <span>{t('order.merci-command')+' '+order.status.date??''}</span>;
            status = "Inconnue"
        }
        
        return(
        <>
            <label className="order-status" style={{fontWeight:'bold'}}>{_status(status).toUpperCase()}</label><br/>
                <label className="order-content-info" style={{color:'gray'}}>
                    {text}
                </label>
        </>)
    }

    const TotalPayments = ()=>{
        let total = 0;
        order.payments.map((paie)=>{
            total = total + Number(paie.mount);
        });
        let color = 'green';
        if(total<order.total_price)
            color = 'red';

        return <label style={{margin:'auto'}}><b><span style={{color:color}}>{total} {AppState.settings.devise==='euro'?' €':' KMF'}</span> /{order.total_price} {AppState.settings.devise==='euro'?' €':' KMF'}</b></label>;
    }

    const CancelOrder = ()=>{
        const data = {order_id:order.id}
        fetchData.PutData(data,`user/order/`).then(async (result)=>{
            if(result.result)
            {setOrder({...result.order});console.log(result);}
        })
    }

    /*
    const Invoice = ()=>{
        if(order.id === undefined)
            return null;
        return {
                number: 'INV-'+order.order_number,
                status: order.status==='en attente' ? 'Non Payée' : 'Payée',
                date: order.date.split('T')[0],
                contact: 'djamnazi@always-data.fr',
                payment: order.payments.length>0 ? order.payments.map(p => p.mode).join(', ') : 'N/A',
                collectedBy: order.payments.length>0 ? order.payments.map(p => p.cashier.name).join(', ') : 'N/A',
                items: order.articles.map(art=>({
                    name: art.title,
                    variant: art.deliver ? art.deliver.title : 'N/A',
                    qty: art.quantity,
                    price: art.price
                })),
                shipping: 4.90,
                vatRate: 0.00
        };
    }
    */
    return(<div className="order">
        <div className="order-div" >
            <h4 className="order-title">{t('order.commande')}</h4>
            <div className="order-content">
                <div style={{display:'inline-block',fontSize:'small',verticalAlign:'middle',margin:'auto'}}>
                    <label>{order.order_number}</label>
                    <label style={{display:'block',color:'gray'}}>{order.date}</label>
                </div>
                {/*
                <div className="p-4 bg-white shadow-lg rounded">
                    { order.owned && <QRCodeSVG value={order.customer_ticket} size={100} />}
                </div>
                */}
                <div style={{display:'inline-block',fontSize:'small',width:'50%',verticalAlign:'middle'}}>
                    <TicketViewPopUp order={order} data_ticket={order.customer_ticket} enable_download={true} is_delivry={false} />
                </div>
            </div>
        </div>
        <div className="order-div">
            <h4 className="order-title">{t('order.status')}</h4>
            <div className="order-content">
                {Status()}
            </div>
        </div>
        <div className="order-div">
            <h4 className="order-title">{t('order.articles')}</h4>
            <div className="order-content">
            {order.articles.map((art,index)=>{
                let borderBottom = '1px solid lightgray';
                if(index===order.articles.length-1)
                    borderBottom = 'none'
                return(
                <div style={{borderBottom:borderBottom}} className="order-article" key={index}>
                    <img onClick={e=>{navigator(`/product/${art.article_id}`)}} src={MediaUrl(art.image)} className="order-article-img"/>
                    <div className="order-article-info" >
                        <label className='order-article-title'>{art.title}</label><br/>
                        <label className="order-article-text" style={{color:'gray'}}>
                            <span className="order-article-item" style={{marginRight:'20px'}}>{t('produit.quantite')} {art.quantity}</span>
                            <span style={{marginRight:'10px'}}>{t('produit.prix')} : {art.price}</span>
                            {Promo(art)}
                            {(!!art.status) && 
                            <div>
                                <span style={{marginRight:'10px',color:'violet'}}>{t('order.status').toLowerCase()} : {Status_article(art.status)}</span>
                            </div>
                            }
                        </label>
                    </div>
                    <div className="order-delivery-div" style={{marginTop:'10px'}}>
                        <label className="order-delivery-label">{t('order.livreur')} </label>
                        <div className="order-select-location">
                            <Select 
                                isDisabled
                                value={PartnerOption(art.deliver)}
                                options={[PartnerOption(art.deliver)]}
                            />
                        </div>
                </div>
                </div>)
            })}
            <MobileView>
                <input onClick={e=>{setScanner({...scanner,display:'block'})}} type="button" value={"Recuperer un colis"} style={{border:'1px solid lightgray',height:'40px',borderRadius:'5px',fontSize:isMobile?'x-small':'small',width:'80%',backgroundColor:'skyblue'}} />
                {(scanner.display==='block') && <ButtonQrPackage close={()=>{setScanner({...scanner,display:'none'})}} />} 
            </MobileView>
            </div>
        </div>
        <div className="order-div">
            <h4 className="order-title">{t('order.livraison')}</h4>
            <div className="order-content">
                <div className="order-delivery-div" style={{marginTop:'10px'}}>
                    <label className="order-delivery-label"  >{t('user-info.addresse')} </label>
                    <div className="order-select-location" >
                        <Select isDisabled value={locations[0]} />
                    </div>
                </div>
                <div className="order-delivery-div" style={{marginTop:'10px'}}>
                    <BrowserView className="order-delivery-label">
                        <label>{t('order.commentaires')}</label>
                    </BrowserView>
                    <textarea disabled={order.owned} className="order-select-location" style={{minHeight:'80px',textAlign:'center',border:'1px solid lightgray',fontSize:isMobile?'x-small':'x-small',borderRadius:'5px'}} placeholder={t("order.precision-livraison")} />
                </div>
                <div className="order-delivery-div" style={{marginTop:'10px',verticalAlign:'middle',display:'flex',flexDirection:'row'}}>
                    <label className="order-delivery-label" style={{display:'inline-block'}}>{t('filters.prix')}</label>
                    <MobileView className="order-select-location" style={{verticalAlign:'middle',display:'inline-block',marginLeft:'10px',width:'fit-content'}}><span style={{fontWeight:'bold'}}>{order.delivery_price} {AppState.settings.devise==='euro'?' €':' KMF'}</span></MobileView>
                    <BrowserView className="order-select-location">
                        <label style={{textAlign:'left'}}>{order.delivery_price} {AppState.settings.devise==='euro'?' €':' KMF'}</label>
                    </BrowserView>
                </div>
            </div>
        </div>
        <div className="order-div">
            <h4 className="order-title">{t('order.paiements')}</h4>
            <div className="order-content">
                {order.payments.map((payment,index)=>{
                    let borderBottom = '1px solid lightgray';
                    if(index===order.payments.length-1)
                        borderBottom = 'none'
                    return(
                    <div style={{borderBottom:borderBottom, padding:'10px 0px 10px 0px',borderRadius:'5px',margin:'5px'}}>
                        <div className="order-delivery-div" style={{textAlign:'left',marginLeft:'30px'}}>
                            <label className="order-delivery-label" style={{textAlign:'left'}}>{t('order.date-paiement')} : </label>
                            <label className="order-select-location" style={{color:'gray',fontSize:'small'}}>{payment.date}</label>
                        </div>
                        <div className="order-delivery-div" style={{textAlign:'left',marginLeft:'30px'}}>
                            <label className="order-delivery-label" style={{textAlign:'left'}}>{t('order.mode-paiement')} : </label>
                            <label className="order-select-location" style={{color:'gray',fontSize:'small'}}>{payment.mode}</label>
                        </div>
                        <div className="order-delivery-div" style={{textAlign:'left',marginLeft:'30px'}}>
                            <label className="order-delivery-label" style={{textAlign:'left'}}>{t('order.montant')} : </label>
                            <label className="order-select-location" style={{fontWeight:'bold',fontSize:'small'}}>{payment.mount} €</label>
                        </div>
                        <div className="order-delivery-div" style={{textAlign:'left',marginLeft:'30px'}}>
                            <label className="order-delivery-label" style={{textAlign:'left'}}>{t('order.encaisse-par')} : </label>
                            <label className="order-select-location" style={{color:'gray',fontSize:'small'}}>{payment.cashier.name}</label>
                        </div>
                    </div>);
                })}
                {(order.payments.length>0)&& (<div className="order-delivery-div" style={{textAlign:'left',marginLeft:'30px',borderTop:'1px solid lightgray',paddingTop:'5px'}}>
                            <label className="order-delivery-label" style={{textAlign:'left',fontWeight:'bold'}}>{t('panier.total')} : </label>
                            <label className="order-select-location" style={{color:'gray',fontSize:'small'}}>{TotalPayments()}</label>
                        </div>)}
                {(order.payments.length===0)&& (<span style={{color:'gray'}}>{t('order.aucun-paiement')}</span>)}
            </div>
        </div>
        {/*
        <div className="order-div">
            <h4 className="order-title">{t('order.total')}</h4>
            <div className="order-content" style={{margin:'auto',marginTop:'15px',width:'70%'}}>
                {TotalPayments()}
            </div>
        </div>*/}
        { (order.historic.length > 0) &&
            <div className="order-div">
                <BrowserView style={{display:'inline-block',width:'100%'}}>
                    <h4 className="order-title" style={{width:'100%'}}>Historique</h4>
                </BrowserView>
                <MobileView>
                    <h4 className="order-title">{t('order.suivi')}</h4>
                </MobileView>
                <div className="order-content" style={{marginTop:'10px',width:'75%',margin:'auto',fontSize:'small'}}>
                    {order.historic.map((item, index)=>{
                        let border = '1px solid lightgray';
                        if(index===order.historic.length-1)
                            border = 'none'
                        return(
                            <SaleComment comment={item} editable={false} border={border} />
                        )
                    })}
                </div>
        </div>
        }
        <div style={{marginTop:'0px',display:'flex',justifyContent:'center',flexDirection:'row',alignItems:'center'}}>
            {(_status(order.status)!=='Annulee') && <input className="order-btn" type="button" onClick={()=>{CancelOrder()}} value={t('ajout-produit.annuler')} style={{backgroundColor:'#FFCBCC',marginRight:'10px'}}  />}
            {order.owned && <div>
            {invoice !== undefined && AppState.settings.lang!=='ar' &&
                <PDFDownloadLink style={{padding:'8px 20px 14px 20px',backgroundColor:'whitesmoke',color:'black',textDecoration:'none',borderRadius:'5px',border:'none'}}
                    document={<InvoiceDocument invoice={invoice} />}
                    fileName="facture-INV-2024-00142.pdf"
                    >
                    {({ loading }) =>
                        loading ? 'Génération...' : 'Facture PDF'
                    }
                </PDFDownloadLink>}
                {invoice !== undefined && AppState.settings.lang==='ar' && <label style={{fontSize:'small',color:'red'}}>{t('order.facture-not-available')}  </label>}
            </div>}
        </div>
    </div>); 
} 